import { atom } from 'recoil';

export const token = atom<string | null>({
  key: 'token',
  default: null,
});
